import http from 'conversations-http/clients/http';
import { convertFiltersToSearchArgs } from '../operators/convertFiltersToSearchArgs';
import { getFilterValues } from '../operators/filterKeyGetters';
export const doesThreadMatchFilters = ({
  threadId,
  filterKey,
  inboxId
}) => {
  const {
    assignment = null,
    endTimestamp = null,
    hideFiltered = true,
    searchQuery = null,
    startTimestamp = null,
    genericChannelIds = null,
    threadStatus = null,
    vids = null
  } = convertFiltersToSearchArgs(getFilterValues(filterKey));
  return http.put(`messages/v2/threadlist/member/${threadId}/details/match`, {
    data: {
      assignment,
      endTimestamp,
      hideFiltered,
      inboxId,
      searchQuery,
      startTimestamp,
      genericChannelIds,
      threadStatus,
      vids
    }
  });
};